/* tjs <- configure-tjs-safe.ts */

import { configureTjs } from './configure-tjs'

configureTjs({ throwTypeErrors: false, logTypeErrors: false });